import React from 'react'
import { Dropdown, Menu, Space } from 'antd';

export default function ListData(props) {
    console.log(props.is_DefaultSelected,'isprimary')
    console.log(props)
    const menu = (
        <Menu
          items={[
            {
                key: '1',
                label: (
                    <span className='font-weight-400 font-14 pl-10 mb-1-rem' id={props.values.key}  onClick={props.editBank}>Edit</span>
                ),
            },
     
          ]}
        />
      );
    return (
        <tr className='customer_supplier_row font-weight-600 font-13 color-707895'>
            <td>{props.values.directorName}</td>
            <td>{props.values.directorDesignation}</td>
            <td>{props.values.directorNationality}</td>
            <td>{props.values.directorNationalIdentityNo}</td>
            <td>{props.values.appointedDate}</td>
            <td style={{top:'5px', position:'relative'}}>{props.is_Default &&
                    <span className='contact-form-primary-badge'>Primary</span>
                }
            </td>
            <td>
            <Dropdown overlay={menu}>
                <a onClick={(e) => e.preventDefault()}>
                <Space>

                      <img src = '/assets/images/Dot_icon.svg' />

                  </Space>
                </a>
            </Dropdown>
            </td>
        </tr>
    )
}
